import * as R from 'ramda';
import { IJsonQuery } from '@cian/api-models/common/json_query';

import { ESuburbanUtility, NonEmptyArray } from './types';
import { resetTerms, setTerm } from './helpers';

export function setSuburbanUtilities(jsonQuery: IJsonQuery) {
  return (suburbanUtilities: NonEmptyArray<ESuburbanUtility> | null): IJsonQuery => {
    let nextJsonQuery = R.clone(jsonQuery);

    nextJsonQuery = resetTerms(['electricity', 'has_drainage', 'has_water', 'gas'])(nextJsonQuery);

    if (suburbanUtilities) {
      if (suburbanUtilities.includes(ESuburbanUtility.Electricity)) {
        nextJsonQuery = setTerm('electricity')(nextJsonQuery)(true);
      }

      if (suburbanUtilities.includes(ESuburbanUtility.Drainage)) {
        nextJsonQuery = setTerm('has_drainage')(nextJsonQuery)(true);
      }

      if (suburbanUtilities.includes(ESuburbanUtility.Water)) {
        nextJsonQuery = setTerm('has_water')(nextJsonQuery)(true);
      }

      if (suburbanUtilities.includes(ESuburbanUtility.Gas)) {
        nextJsonQuery = setTerm('gas')(nextJsonQuery)(true);
      }
    }

    return nextJsonQuery;
  };
}
